import { FileModel } from '../files/file.model';

export class MessageModel {
  id: string;
  messageTypeId: number;
  subject: string;
  fromName: string;
  fromAddress: string;
  toAddress: string;
  organisationId: string;
  createdOn: Date;
  sentOn: Date;
  attachments: number;
  size: number;
  plainTextBody: string;
  status: MessageStatuses;
  isNew: boolean;
  interactionStatus: InteractionStatuses;

  files: FileModel[];

  // ui property for chat
  myMessage?: boolean;

  // public object1KeyField: string;
  // public object1KeyValue: string;
  // public object2KeyField: string;
  // public object2KeyValue: string;
}

export enum MessageStatuses {
  Unknown = 0,
  Processed = 1,
  ManualAction = 2,
}

export enum InteractionStatuses {
  None = 0,
  Unread = 1,
  Read = 2,
  Replied = 3,
}

export interface ChatMessageModel {
  message: string;
  contentMapObject: any;
}
